import React from "react";
import Button from "./UI/Button";

const renderActionButton = (type, action, coloring) => {
  return (
    <Button type="button" coloring={coloring} onClick={() => action()}>
      {type}
    </Button>
  );
};

export default renderActionButton;
